import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const Features = () => {
    useEffect(() => {
        // Force hide spinner immediately
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
            spinner.style.opacity = '0';
            spinner.style.visibility = 'hidden';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
    }, []);

    return (
        <>
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start */}
            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <h1 className="display-3 mb-4 animated slideInDown">Features</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item"><a href="/feature">Pages</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Features</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            {/* Features Start */}
            <div className="container-xxl feature py-5">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                            <p className="d-inline-block border rounded text-primary fw-semi-bold py-1 px-3">Why Choosing Us!</p>
                            <h1 className="display-5 mb-4">Few Reasons Why People Choosing Us!</h1>
                            <p className="mb-4">With a team of eight highly skilled professionals, we bring a wealth of expertise to the table.
                                From web design to development and digital marketing, we have the skills needed to turn your vision into reality.
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row g-4 align-items-center">
                                <div className="col-md-6">
                                    <div className="row g-4">
                                        <div className="col-12 wow fadeIn" data-wow-delay="0.3s">
                                            <div className="feature-box border rounded p-4">

                                                <h4 className="mb-3">Creativity <i className="bi bi-patch-check-fill text-primary mb-3"></i></h4>
                                                <p className="mb-3">Just like bears in the wild, our team is known for its creativity.
                                                    We approach each project with a fresh perspective,
                                                    ensuring that your online presence stands out in a crowded digital landscape.</p>
                                            </div>
                                        </div>
                                        <div className="col-12 wow fadeIn" data-wow-delay="0.5s">
                                            <div className="feature-box border rounded p-4">

                                                <h4 className="mb-3">Client-Centric <i className="bi bi-patch-check-fill text-primary mb-3"></i></h4>
                                                <p className="mb-3">Your success is our success. We work closely with you to understand your unique goals and tailor our solutions to meet your specific needs.
                                                    Your satisfaction is our top priority.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 wow fadeIn" data-wow-delay="0.7s">
                                    <div className="feature-box border rounded p-4">

                                        <h4 className="mb-3">Roaring Results <i className="bi bi-patch-check-fill text-primary mb-3"></i></h4>
                                        <p className="mb-3">Our tagline, "Unleash Your Brand &amp; Roar With WebBears," isn't just a catchy phrase; it's a promise. We are dedicated to delivering results that make your brand roar in the online jungle.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Features End */}

            <Footer />
        </>
    );
};

export default Features;
